<mat-divider></mat-divider>
<div class="section-label">
  <span class="review_edit-area">
    <ng-container *ngIf="reviewState === reviewStates.ReadOnly">
      <app-icon-button
        icon="edit"
        label="EDIT"
        (click)="editDetails()"
      ></app-icon-button>
    </ng-container>
    <ng-container *ngIf="reviewState === reviewStates.Edit">
      <a mat-button target="_blank" class="buttonLink" (click)="save()">Save</a>
      <a mat-button target="_blank" class="buttonLink" (click)="cancel()"
        >Cancel</a
      >
    </ng-container>
  </span>
</div>
<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <h3 class="section-sub-label">Employment Details</h3>
  <div *ngIf="reviewState !== reviewStates.ReadOnly" class="subtitle-margin">
    <div class="employmentDetailsInfo">
      To comply with regulations, we need to collect information about your
      primary source of income. This information is federally required.
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="10px"
  >
    <div
      fxFlex="50"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState !== reviewStates.ReadOnly"
        id="incomeSource-label"
        for="incomeSource"
        >{{ reviewState !== reviewStates.ReadOnly ? "*" : ""
        }}<label for="incomeSource">Primary Source of Income</label>
      </mat-label-tooltip>
      <div *ngIf="reviewState !== reviewStates.ReadOnly" class="form-input">
        <mat-form-field appearance="outline" id="mff_incomeSource">
          <mat-select
            matInput
            placeholder="-Select-"
            required
            id="incomeSource"
            formControlName="incomeSource"
            data-dd-privacy="mask-user-input"
            [compareWith]="compareValueWithSelection"
            [aria-label]="
              isPrimary
                ? 'Primary applicant primary source of income'
                : 'Co-applicant primary source of income'
            "
          >
            <mat-option
              *ngFor="let curSource of incomeSourceList"
              [value]="curSource.incomeSourceId"
            >
              {{ curSource.incomeSourceName }}</mat-option
            >
          </mat-select>
          <mat-error>{{ this.getFieldError("incomeSource") }}</mat-error>
        </mat-form-field>
      </div>
      <div
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label class="read-only-label" data-dd-privacy="mask">{{
          getIncomeSourceDescription()
        }}</mat-label>
      </div>
    </div>
    <div
      fxFlex="50"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState !== reviewStates.ReadOnly"
        id="occupation-label"
        for="occupation"
      >
        <label for="occupation"
          >{{
            reviewState !== reviewStates.ReadOnly ? "*" : ""
          }}Occupation</label
        >
      </mat-label-tooltip>
      <div *ngIf="reviewState !== reviewStates.ReadOnly" class="form-input">
        <mat-form-field appearance="outline" id="mff_occupation">
          <mat-select
            matInput
            placeholder="-Select-"
            required
            id="occupation"
            formControlName="occupation"
            data-dd-privacy="mask-user-input"
            [compareWith]="compareValueWithSelection"
            [aria-label]="
              isPrimary
                ? 'Primary applicant occupation'
                : 'Co-applicant occupation'
            "
          >
            <mat-option
              *ngFor="let curOccupation of occupationList"
              [value]="curOccupation.occupationId"
            >
              {{ curOccupation.occupationName }}</mat-option
            >
          </mat-select>
          <mat-error>{{ this.getFieldError("occupation") }}</mat-error>
        </mat-form-field>
      </div>
      <div
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label class="read-only-label" data-dd-privacy="mask">{{
          getOccupationDescription()
        }}</mat-label>
      </div>
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="10px"
  >
    <div
      fxFlex="50"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState !== reviewStates.ReadOnly"
        id="employerCountry-label"
        for="employerCountry"
        ><label for="employerCountry"
          >{{ reviewState !== reviewStates.ReadOnly ? "*" : "" }}Employer
          Country</label
        >
      </mat-label-tooltip>
      <div *ngIf="reviewState !== reviewStates.ReadOnly" class="form-input">
        <mat-form-field appearance="outline" id="mff_employerCountry">
          <mat-select
            matInput
            placeholder="-Select-"
            required
            id="employerCountry"
            formControlName="employerCountry"
            data-dd-privacy="mask-user-input"
            [compareWith]="compareValueWithSelection"
            [aria-label]="
              isPrimary
                ? 'Primary applicant employer country'
                : 'Co-applicant employer country'
            "
          >
            <mat-option
              *ngFor="let curCountry of countryList"
              [value]="curCountry.countryId"
              >{{ curCountry.countryName }}
            </mat-option>
          </mat-select>
          <mat-error>{{ this.getFieldError("employerCountry") }}</mat-error>
        </mat-form-field>
      </div>
      <div
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label class="read-only-label" data-dd-privacy="mask">{{
          getCountryDescription()
        }}</mat-label>
      </div>
    </div>
    <div
      fxFlex="50"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState !== reviewStates.ReadOnly"
        id="annualIncome-label"
        for="annualIncome"
        ><label for="annualIncome"
          >{{ reviewState !== reviewStates.ReadOnly ? "*" : "" }}Annual
          Income</label
        >
      </mat-label-tooltip>
      <div *ngIf="reviewState !== reviewStates.ReadOnly" class="form-input">
        <mat-form-field appearance="outline" id="mff_annualIncome">
          <mat-select
            matInput
            placeholder="-Select-"
            required
            id="annualIncome"
            formControlName="annualIncome"
            data-dd-privacy="mask-user-input"
            [compareWith]="compareValueWithSelection"
            [aria-label]="
              isPrimary
                ? 'Primary applicant annual income'
                : 'Co-applicant annual income'
            "
          >
            <mat-option
              *ngFor="let curAnnualIncome of annualIncomeList"
              [value]="curAnnualIncome.annualIncomeId"
            >
              {{ curAnnualIncome.displayValue }}
            </mat-option>
          </mat-select>
          <mat-error>{{ this.getFieldError("annualIncome") }}</mat-error>
        </mat-form-field>
      </div>
      <div
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label class="read-only-label" data-dd-privacy="mask">{{
          getAnualIncomeDescription()
        }}</mat-label>
      </div>
    </div>
  </div>
</form>
<br />
